<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        AuthenticationViaToken,
        CAMPAIGN_TOKEN,
        ConfirmEmail,
        IS_AUTHENTICATED,
        IS_ORGANIZATION_APPROVED,
        Messenger,
        NukeSession,
        UndoCountdown,
        UnsubscribeOnboarding,
    } from '@smatch/cassiopeia-web-components';

    // ROUTES / PAGES
    import Authentication from './routes/authentication/Router.svelte';
    import Onboarding from './routes/onboarding/Router.svelte';
    import Auctions from './routes/auctions/Router.svelte';
    import Subscriptions from './routes/subscriptions/Router.svelte';
    import Landing from './routes/landing/Router.svelte';

    // GUARDS
    import UnauthenticatedGuard from './guards/UnauthenticatedGuard.svelte';
    import AuthenticatedAndApprovedGuard from './guards/AuthenticatedAndApprovedGuard.svelte';
    import AuthenticatedNotApprovedGuard from './guards/AuthenticatedNotApprovedGuard.svelte';

    // PLUGINS
    import { Router, Route, navigate } from 'svelte-navigator';
    import { onMount } from 'svelte';

    $: ({ hash } = window.location);

    onMount(() => {
        const { hash: HASH, search: SEARCH } = window.location;
        const REDIRECT_URL = new URLSearchParams(SEARCH).get('url');

        if (window.location.pathname !== '/') {
            return;
        }

        if (!$IS_AUTHENTICATED && $CAMPAIGN_TOKEN === undefined) {
            navigate(`/authentication${ SEARCH }${ HASH }`);
            return;
        }

        if (!$IS_ORGANIZATION_APPROVED && $CAMPAIGN_TOKEN === undefined) {
            navigate(`/onboarding${ SEARCH }${ HASH }`);
            return;
        }

        navigate(REDIRECT_URL === null ? '/auctions' : decodeURIComponent(REDIRECT_URL));
    });

</script>

<Router>

    <Messenger />
    <UndoCountdown />

    {#if hash === '#one-time-link'}
        <AuthenticationViaToken />
    {/if}

    {#if hash === '#confirm-email'}
        <ConfirmEmail />
    {/if}

    {#if hash === '#nuke-session'}
        <NukeSession />
    {/if}

    {#if hash === '#unsubscribe-onboarding'}
        <UnsubscribeOnboarding />
    {/if}

    <Route path = '/authentication/*'>
        <UnauthenticatedGuard>
            <Authentication />
        </UnauthenticatedGuard>
    </Route>

    <Route path = '/onboarding/*'>
        <AuthenticatedNotApprovedGuard>
            <Onboarding />
        </AuthenticatedNotApprovedGuard>
    </Route>

    <Route path = '/landing/*'>
        <Landing />
    </Route>

    <Route path = '/auctions/*'>
        <AuthenticatedAndApprovedGuard>
            <Auctions />
        </AuthenticatedAndApprovedGuard>
    </Route>

    <Route path = '/subscriptions/*'>
        <AuthenticatedAndApprovedGuard>
            <Subscriptions />
        </AuthenticatedAndApprovedGuard>
    </Route>

    <Route>
        <a href = '/' style = 'text-decoration: underline'>
            Sorry, page not found. Please click here to go to the home page.
        </a>
    </Route>

</Router>